import React, { VFC } from 'react';
import { Organization } from 'src/common/interfaces/organization.interface';
import { OrganizationForm } from 'src/dashboard/forms/organization-form';

interface DashboardSettingsOrganizationProps {
  currentOrganization: Organization;
  onSuccess: (organization: Organization) => void;
}

export const DashboardSettingsOrganization: VFC<DashboardSettingsOrganizationProps> = ({
  currentOrganization,
  onSuccess,
}) => {
  return (
    <div className='mt-4'>
      <OrganizationForm
        formClassName='w-[320px]'
        currentOrganization={currentOrganization}
        onSubmit={onSuccess}
        submitLabel='Save'
        showGuidance={true}
      />
    </div>
  );
};
